import NextLink, { LinkProps } from 'next/link';

export const Link = (allProps: React.PropsWithChildren<LinkProps>): JSX.Element => {
  const { children, ...props } = allProps;
  return <NextLink {...props}>{children}</NextLink>;
};
